import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import clsx from "clsx";
import { Button, Stack } from "@curves/ui-base";
import { v4 as uuid } from "uuid";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import MobileCarrierBarCode from "./MobileCarrierBarCode";
import { isEmpty, isFunction } from "@util/utils";

/**
 * 手機載具條碼掃描彈窗
 *
 * @param {{
 *   open: boolean,
 *   sourceData?: Object,
 *   onClose: (errorMessage?: string) => void,
 * }} props 掃描成功與錯誤關閉的回呼函式
 * @param {React.Ref<HTMLDivElement>} ref 掃描框容器的 ref（可選）
 * @returns {JSX.Element}
 *
 */
const MobileCarrierBarCodeDialog = React.forwardRef((props, ref) => {
	const { open, sourceData, onClose } = props;
	if (!open) return null;
	const { onScanSuccess, onScanError, onSave } = sourceData || {};
	const [mobileCarrierBarCodeKey] = useState(uuid());
	const [value, setValue] = useState(null);
	const handleOnclose = () => {
		onClose();
	};

	const handleScanSuccess = decodedText => {
		isFunction(onScanSuccess) && onScanSuccess(decodedText);
		setValue(decodedText);
	};

	const handleScanError = errorMessage => {
		isFunction(onScanError) && onScanError(errorMessage);
	};

	const handleSave = () => {
		isFunction(onSave) && onSave(value);
		onClose();
	};

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-80rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={handleOnclose}>{"手機載具掃描"}</GradientColorHeader>
			<DialogContent className={"pt-4 px-4 pb-4"}>
				<MobileCarrierBarCode key={mobileCarrierBarCodeKey} onScanSuccess={handleScanSuccess} onScanError={handleScanError} />
			</DialogContent>
			<DialogActions>
				<Stack spacing={2}>
					<Button variant="contained" onClick={handleSave} disabled={isEmpty(value)}>
						儲存
					</Button>
					<Button variant="outlined" onClick={handleOnclose}>
						關閉
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
});

export default MobileCarrierBarCodeDialog;
